<template>
  <input-select
    id="input:produtoServicoCategoria"
    v-model="payload.produtoServicoCategoria"
    :rules="[requiredRule]"
    :items="produtoServicoCategoriaOptions"
    label="Categoria do produto"
    :loading="loading"
    v-bind="attrs"
    required
    clearable
  />
</template>

<script>
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import ProductCategory from '@/app/arch/enums/ProductCategory';

export default {
  name: 'ProdutoCategoria',
  mixins: [RulesMixin],
  props: {
    payload: {
      type: Object,
      default() {
        return {
          produtoServicoCategoria: '',
        };
      },
    },
    loading: {
      type: Boolean,
    },
  },
  data: () => ({
    produtoServicoCategoriaOptions: ProductCategory,
  }),
  computed: {
    isEdit() {
      return this.$route.params.id;
    },
    attrs() {
      return {
        disabled: this.isEdit,
        ...this.$attrs,
      };
    },
  },
};
</script>
